import { useDispatch, useSelector } from 'react-redux'
import { logoutSuccessful, userDetailsSelector } from '../../redux/slices/userSlice'
import { extractErrorMessage } from '../../../config';
import { startGlobalLoading, stopGlobalLoading } from '../../redux/slices/themeSlice';

export function useApiCall() {

    const dispatch = useDispatch()
    const { token } = useSelector(userDetailsSelector);
    // //console.log(token)

    const callApi = (sagaAction, dataOrParams = {}, callbackSuccess, callbackError, tokenReq = true) => {
        dispatch(startGlobalLoading())
        let payload = { data: dataOrParams }
        if (tokenReq) {
            payload = { data: dataOrParams, token: token }
        }

        dispatch({
            type: sagaAction,
            payload: payload,
            callbackSuccess: (data) => {
                dispatch(stopGlobalLoading())

                let message = data && data?.message ? data?.message : 'Request processed successfully'
                let resp = data && data?.data ? data?.data : null
                callbackSuccess && callbackSuccess(message, resp, data)

            },
            callbackError: (error) => {
                dispatch(stopGlobalLoading())

                if (error?.statusCode === 401) {
                    dispatch(logoutSuccessful())
                }

                let message = error && error?.error ? extractErrorMessage(error) : typeof error?.message === 'object' ? extractErrorMessage(error?.message) : error?.message ?? 'Unable to process, please try again'
                let resp = error && error?.data ? error?.data : null
                callbackError && callbackError(message, resp, error)
            }
        })
    }
    return callApi
}